import clsx, { ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
import config from '../../tailwind.config';

export const twMerge = extendTailwindMerge({
  // @ts-ignore
  classGroups: {
    'font-size': Object.keys(config.theme.fontSize).map((key) => `text-${key}`),
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
